import { useIntParam } from 'hooks';
import { lrwSessionStore } from 'store';

export const useLrwSessionRooms = () => {
  const sessionId = useIntParam('sessionId');
  const { isFetching, data: lrwRooms } =
    lrwSessionStore.service.lrwSessionApi.useGetLrwSessionAssignedRoomsQuery({
      lrwSessionId: sessionId,
    });

  return { isFetching, lrwRooms };
};
